export default __webpack_public_path__ + "static/media/banner.5a8ff2ab.jpeg";